import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';
import WorksitePhaseTrustUpIOTaskCollection from  '@spa/apps/trustup-pro-worksite-js/collections/WorksitePhaseTrustUpIOTaskCollection';

export default class WorksitePhase extends BaseModel
{
    
    init(data)
    {
        super.init(data);

        if ( this.trustup_io && this.trustup_io.tasks ) {
            this.trustup_io.tasks.tasks = new WorksitePhaseTrustUpIOTaskCollection(
                this.trustup_io.tasks.tasks || [],
                this
            );
        }
    }

    /**
     * When refreshing the model we might not have tasks collection defined yet
     * because the data might come from a different API endpoint that didn't load the tasks.
     * If that's the case, we simply add them back before calling the init method.
     */
    initOnRefresh(data)
    {
        console.log(this.trustup_io.tasks.tasks.length(), data.trustup_io.tasks.tasks);
        if ( this.trustup_io && this.trustup_io.tasks && this.trustup_io.tasks.tasks.length() > 0 && data.trustup_io && data.trustup_io.tasks && ! data.trustup_io.tasks.tasks ) {
            data.trustup_io.tasks.tasks = this.trustup_io.tasks.tasks.items;
        }

        super.initOnRefresh(data);
    }

    destroy()
    {
        if ( this.trustup_io && this.trustup_io.tasks ) {
            this.trustup_io.tasks.tasks.destroy();
        }
        super.destroy();
    }

    static getPrefix()
    {
        return 'worksite:worksite-phase';
    }

    static getEndpoint(worksite)
    {
        return window.Worksite.endpoints.worksitePhase.setWorksite(worksite);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.worksite);
    }

    static getParentEndpoint()
    {
        return window.Worksite.endpoints.worksite;
    }

    data() {
        return {
            id: this.id,
            uuid: this.uuid,
            title: this.title,
            starts_at: this.starts_at,
            ends_at: this.ends_at
        }
    }

    edit(data = {})
    {
        return super.edit({
            ...data,
            ...{
                worksite: this.currentCollection.worksite
            }
        });
    }

};